import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      domesticSearchPreview: {
        PRICE: 'Price:',
        TRADE_DISCOUNT: 'Trade Discount',
        TAX_CODE: 'Tax Code',
        PHONE: 'Phone',
        REGISTERED_ADDRESS: 'Registered Address',
        INDUSTRY: 'Industry',
        ENTERPRISE_STATUS: 'Enterprise Status',
        YEARS_OF_OPERATION: 'Years in Operation',
        DATE_OF_REGISTRATION: 'Date of Registration',
        LEGAL_FORM: 'Legal Form',
        LOCATION: 'Location',
        YEARS: 'Years',
        YEAR: 'Year',
        DOMESTIC_SEARCH_TOTAL_ASSET: 'Total Assets',
        DOMESTIC_SEARCH_TOTAL_REVENUE: 'Revenue',
        DOMESTIC_SEARCH_TOTAL_OPERATING_INCOME: 'Total Operating Income',
        DOMESTIC_SEARCH_INSURANCE_PREMIUM: 'Insurance Premium',
        ADD_TO_CART: 'Add To Cart',
        BUY_NOW: 'Buy Now',
        TOTAL: 'Total',
        BUSINESS_CREDIT_REPORT: 'Business Credit Report',
        BUSINESS_CREDIT_REPORT_DESCRIPTION: `Our business reports provide comprehensive business insights
          including company information, operational situation, financial
          viability, business risk & outlook. Using an extensive database of
          domestic and FDI businesses that are fact-checked and analyzed by our
          specialist team, we offer a variety of report types to suit your
          research needs.`,
        CONTACT_US: 'Contact Us',
        SERVICE_DETAIL: 'Service details',
        UNAVAILABLE: 'Unavailable',
        CHECK_DATA_AVAILABILITY: 'Check data availability',
        COMPANY_PROFILE: 'Company Profile',
        OWNERSHIP_GROUP: 'Ownership and Group',
        FINANCIAL_STATEMENT: 'Financial Statements',
        HOW_TO_SET_YOUR_FT: 'How to set your Financial Statement',
        SOURCE: 'Source',
        TYPE_OF_FT: 'Type of Financial Statements',
        REPORTING_YEAR: 'Reporting Year',
        AUDIT_STATUS: 'Audit Status',
        METHOD: 'Method',
        DATA_AVAILABILITY: 'Data Availability',
        FREE_WHEN_PURCHASE: 'Free when purchase with Financial Statements',
        CURRENT_PLAN: 'Current Plan',
        CURRENT_PLAN_DESCRIPTION:
          'Upgrade now to unlock FiinGate features and enjoy more exclusive services.',
        UPGRADE_NOW: 'Upgrade now',
        RESET: 'Reset',
        FULL_NAME: 'Full name',
        EMAIL: 'Email',
        PHONE_NUMBER: 'Phone number',
        LEAVE_US_A_MESSAGE: 'Leave us a message',
        LEAVE_US_A_MESSAGE_TO_CONTACT:
          'Leave us a message and we will contact you as soon as possible!',
        SUBMIT: 'Submit',
        CANCEL: 'Cancel',
        CLOSE: 'Close',
        INVALID_EMAIL: 'Invalid email address. Please enter the correct email',
        INVALID_PHONE: 'Invalid phone number. Please enter the correct number',
        REQUIRED_FIELD: 'This is a required field!',
        THE_COMPANY_DETAIL_FOR_SOURCED:
          'The company details for [organizationName] are sourced directly or indirectly from official company registries.',
        SETTING_FINANCIAL_STATEMENT: 'Setting Financial Statement',
        CHECK_DATA_AVAILABILITY_CONFIRM:
          'Your request was submitted. After checking data availability, we will notify you via email. Please check your mailbox regularly for our updates. Thank you for using our service!',
        CONTACT_US_CONFIRM:
          'Your request was submitted. Please check your mailbox regularly, we will contact you soon. </br>Thank you for using our service!',
        SCORE: 'Score',
        CHECK_DATA_AVAILABILITY_CONDITIONS:
          "Check availability of the Company's Financial Statements under the above conditions.",
        DISCOUNT_INCLUDE: 'Your current trade discounts include:',
        DISCOUNT_ONE: 'Discount_rate1+Discount_name1+ Due date',
        DISCOUNT_TWO: 'Discount_rate2+Discount_name2+ Due date',
        REGISTRATION_NUMBER: 'Registration Number',
        VAT_NUMBER: 'VAT number',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      domesticSearchPreview: {
        PRICE: 'Giá:',
        TRADE_DISCOUNT: 'Chiết Khấu Thương Mại',
        TAX_CODE: 'Mã Số Thuế',
        PHONE: 'Số Điện Thoại',
        REGISTERED_ADDRESS: 'Địa Chỉ Đăng Ký',
        INDUSTRY: 'Ngành',
        ENTERPRISE_STATUS: 'Trạng Thái Hoạt Động',
        YEARS_OF_OPERATION: 'Số Năm Hoạt Động',
        DATE_OF_REGISTRATION: 'Ngày Đăng Ký',
        LEGAL_FORM: 'Loại Hình Kinh Doanh',
        LOCATION: 'Vị trí',
        YEARS: 'Năm',
        YEAR: 'Năm',
        DOMESTIC_SEARCH_TOTAL_ASSET: 'Tổng Tài Sản',
        DOMESTIC_SEARCH_TOTAL_REVENUE: 'Doanh Thu',
        DOMESTIC_SEARCH_TOTAL_OPERATING_INCOME: 'Doanh Thu Hoạt Động',
        DOMESTIC_SEARCH_INSURANCE_PREMIUM: 'Doanh Thu Phí Bảo Hiểm',
        ADD_TO_CART: 'Thêm vào Giỏ Hàng',
        BUY_NOW: 'Mua ngay',
        TOTAL: 'Tổng',
        BUSINESS_CREDIT_REPORT: 'Business Credit Report',
        BUSINESS_CREDIT_REPORT_DESCRIPTION: `Báo cáo của chúng tôi cung cấp đánh giá toàn diện về thông tin, tình
          hình hoạt động, khả năng tài chính, rủi ro & triển vọng doanh nghiệp.
          Dữ liệu về doanh nghiệp trong nước và doanh nghiệp FDI được đội ngũ
          chuyên gia của chúng tôi xác thực và phân tích, sản xuất nhiều loại
          báo cáo phù hợp với nhu cầu khách hàng.`,
        CONTACT_US: 'Liên Hệ Chúng Tôi',
        SERVICE_DETAIL: 'Chi tiết dịch vụ',
        UNAVAILABLE: 'Không có sẵn',
        CHECK_DATA_AVAILABILITY: 'Kiểm tra tính sẵn có của dữ liệu',
        COMPANY_PROFILE: 'Hồ Sơ Công Ty',
        OWNERSHIP_GROUP: 'Quan Hệ & Sở Hữu',
        FINANCIAL_STATEMENT: 'Báo Cáo Tài Chính',
        HOW_TO_SET_YOUR_FT: 'Hướng dẫn cài đặt Báo Cáo Tài Chính',
        SOURCE: 'Nguồn',
        TYPE_OF_FT: 'Loại Báo Cáo',
        REPORTING_YEAR: 'Năm Báo Cáo',
        AUDIT_STATUS: 'Tình Trạng Kiểm Toán',
        METHOD: 'Phương Pháp',
        DATA_AVAILABILITY: 'Dữ liệu sẵn có',
        FREE_WHEN_PURCHASE: 'Tặng kèm khi chọn mua Báo cáo tài chính',
        CURRENT_PLAN: 'Loại tài khoản hiện tại',
        CURRENT_PLAN_DESCRIPTION:
          'Hãy nâng cấp ngay để mở khóa các tính năng của FiinGate và tận hưởng nhiều dịch vụ độc quyền hơn.',
        UPGRADE_NOW: 'Nâng cấp ngay',
        RESET: 'Đặt lại',
        FULL_NAME: 'Tên đầy đủ',
        EMAIL: 'Email',
        PHONE_NUMBER: 'Số điện thoại',
        LEAVE_US_A_MESSAGE: 'Để lại yêu cầu',
        LEAVE_US_A_MESSAGE_TO_CONTACT:
          'Để lại yêu cầu và chúng tôi sẽ liên hệ bạn sớm nhất có thể!',
        SUBMIT: 'Gửi yêu cầu',
        CANCEL: 'Hủy',
        CLOSE: 'Đóng',
        INVALID_EMAIL:
          'Email không hợp lệ. Vui lòng nhập địa chỉ email chính xác',
        INVALID_PHONE:
          'Số điện thoại không hợp lệ. Vui lòng nhập số điện thoại chính xác',
        REQUIRED_FIELD: 'Đây là 1 trường bắt buộc!',
        THE_COMPANY_DETAIL_FOR_SOURCED:
          'Thông tin chi tiết về công ty [organizationName] được lấy nguồn trực tiếp hoặc gián tiếp từ các cơ quan đăng ký doanh nghiệp chính thức.',
        SETTING_FINANCIAL_STATEMENT: 'Cài đặt cho báo cáo tài chính',
        CHECK_DATA_AVAILABILITY_CONFIRM:
          'Yêu cầu của bạn đã được gửi thành công. Chúng tôi sẽ thông báo kết quả sau khi kiểm tra tính sẵn có của dữ liệu qua email của bạn. Vui lòng, kiểm tra hộp thư của bạn thường xuyên để nắm được các cập nhật. Cảm ơn bạn đã sử dụng dịch vụ của FiinGate!',
        CONTACT_US_CONFIRM:
          'Yêu cầu của bạn đã được gửi thành công. Vui lòng kiểm tra email thường xuyên, chúng tôi sẽ liên hệ bạn sớm nhất có thể. </br>Cảm ơn bạn đã sử dụng dịch vụ của FiinGate!',
        SCORE: 'Điểm số',
        CHECK_DATA_AVAILABILITY_CONDITIONS:
          'Kiểm tra tính sẵn có của Báo cáo tài chính với các điều kiện trên.',
        DISCOUNT_INCLUDE: 'Chiết khấu thương mại hiện tại của bạn bao gồm:',
        DISCOUNT_ONE:
          'Giá_trị_discount_1 + Tên_discount_1 + Ngày hết_hạn_discount',
        DISCOUNT_TWO:
          'Giá_trị_discount_2 + Tên_discount_2 + Ngày hết_hạn_discount',
        REGISTRATION_NUMBER: 'Số Đăng Ký Doanh Nghiệp',
        VAT_NUMBER: 'Số VAT',
      },
    },
  }),
)
